import React, { Component } from 'react';
import {Checkbox, Pagination} from "react-bootstrap";
import { CSVLink } from "react-csv";
import { PAGE_LIMIT } from "../../data/config";
import Table from "./components/Table";
import {capitalize, handleCheckboxChange} from "../../Utils";

class StatsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            report: [],
            id: '',
            sortParam: null,
            sortOrder: 1,
            sortDifference: 0,
            pagesTotal: 0,
            activePage: 1,
        };

        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.report !== this.props.report) {
            this.setState({ report: this.props.report, id: Date.now() });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if (this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1, id: Date.now() });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.props.paramsObj[sortParam];
        const valueIndex = this.state.sortDifference ? 1 : 0;

        report.sort((objA, objB) => {
            let valueA, valueB;

            if(Array.isArray(objA[paramIndex])) valueA = objA[paramIndex][valueIndex] || 0;
            else valueA = objA[paramIndex] || 0;

            if(Array.isArray(objB[paramIndex])) valueB = objB[paramIndex][valueIndex] || 0;
            else valueB = objB[paramIndex] || 0;

            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getExportCsvButton() {
        const { params, paramNames } = this.props;
        let headers = params.map(param => paramNames[param] || capitalize(param));

        return <CSVLink data={this.state.report} headers={headers} className="btn btn-primary">Export CSV</CSVLink>;
    }

    getTable() {
        const { params, paramsObj, total, paramNames, unixParams = {} } = this.props;
        const { report, id, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            const reportPiece = report.slice(pageStart, pageEnd);

            return <Table params={params} paramsObj={paramsObj} report={reportPiece} total={total} paramNames={paramNames} NaNParams={this.props.NaNParams} unixParams={unixParams} id={id} page={activePage} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        return (
            <div>
                {
                    this.props.hideExportButton ?
                        null : this.getExportCsvButton()
                }
                {
                    this.props.hideDifferenceCheckbox ?
                        null :
                        (<div>
                            <Checkbox onChange={this.handleCheckboxChange} name="sortDifference">Sort By Difference</Checkbox>
                        </div>)
                }

                <div style={{ overflow: "auto", maxHeight: '1000px' }}>
                    {this.getTable()}
                </div>

                <Pagination
                    items={Math.ceil(this.state.report.length / PAGE_LIMIT)}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </div>
        );
    }
}

export default StatsTable;



// WEBPACK FOOTER //
// ./src/components/StatsTable/index.js